import { List } from "immutable";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
function payloadFromFormValues(values) {
  const isOkta = values.type === OKTA_TYPE_KEY;
  return {
    title: values.title,
    description: values.description,
    default_roles: List(values.defaultRoles.split(",")),
    default_user_timezone: values.defaultUserTimezone,
    config: {
      type: values.type,
      ...isOkta ? {
        okta_base_url: values.oktaBaseUrl
      } : {
        base_url: values.baseUrl,
        claims: values.claims
      },
      callback_url: values.callbackUrl,
      client_id: values.clientId,
      token_verifier_connect_timeout: values.tokenVerifierConnectTimeout || 10,
      client_secret: typeof values.clientSecret === "undefined" ? { keep_value: true } : { set_value: values.clientSecret }
    }
  };
}
export default payloadFromFormValues;
